const $ = jQuery.noConflict();
import 'select2/dist/js/select2.full.js';

'use strict';
const Select2 = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$select: $('.js-select'),
	$locationSelect: $('.js-location-select'),
	$locationSelectSecond: $('.js-location-select-second'),

	/** @description Initialize */
	init: function() {
		this.locationSelect2(Select2.$locationSelect);
		this.locationSelect2Second(Select2.$locationSelectSecond);
		this.select2(Select2.$select);
		this.populateSelect();
	},

	select2: (selector) => {
		/**
		 * @description Select2 global function
		 * @link Documentation https://select2.org/
		 * @type {object}
		 */
		selector.each(function(e, el) {
			$(el).select2({
				minimumResultsForSearch: 1,
				width: 'style',
				dropdownCssClass: 'custom-class',
				placeholder: '',
			});
		});
	},

	locationSelect2: (selector) => {
		/**
		 * @description Select2 global function
		 * @link Documentation https://select2.org/
		 * @type {object}
		 */

		// Gets data from location-widget.php, from acf
		const location = window.locations;
		const placeholder = window.placeholderText;
		selector.each(function(e, el) {
			$(el).select2({
				minimumResultsForSearch: 1,
				width: 'style',
				dropdownCssClass: 'custom-class',
				placeholder: placeholder,
				data: [
					// Parse location array
					...location.map((item) => {
						return {
							id: item['code'].toLowerCase(),
							text: item['address'].toLowerCase()
						};
					}),
				],
				matcher: Select2.matchCustom
			});
		});
	},

	populateSelect: () => {
		Select2.$locationSelect.on('select2:select', function() {
			const code = $(this).val().toString();
			localStorage.setItem('code', code);
		});

		Select2.$locationSelectSecond.on('select2:select', function() {
			const codeSecond = $(this).val().toString();
			localStorage.setItem('codeSecond', codeSecond);
		});

		const storedValue = localStorage.getItem('input1');
		let codeFirst;
		let codeSecond;
		let txtValFirst;
		let txtValSecond;

		// if (!storedValue) {
		// 	if(!$('.js-location-select').hasClass('select-changed')) {
		// 		codeFirst = localStorage.getItem('codeSecond');
		// 		txtValFirst = $('#select2-location-widget__input-in-from-container').text().toUpperCase() + ` (${codeFirst})`;
		// 	} else {
		// 		codeFirst = inputForms.$domInputCF7From.val();
		// 		txtValFirst = inputForms.$domInputCF7From.val().toUpperCase();
		// 	}

		// 	if(!$('.js-location-select-second').hasClass('select-changed')) {
		// 		codeSecond = localStorage.getItem('code');
		// 		txtValSecond = $('#select2-location-widget__input-in-to-container').text().toUpperCase() + ` (${codeSecond})`;
		// 	}else {
		// 		codeSecond = inputForms.$domInputCF7To.val();
		// 		txtValSecond = inputForms.$domInputCF7To.val().toUpperCase();
		// 	}
		// }

		if (!storedValue) {
			$('.form-block').find('.js-location-select').on('select2:select', function() {
				$('.form-block').find('.js-location-select').addClass('select-changed');
				const codeForm = $(this).val().toString();
				console.log(codeForm);
				const city1 = $('.form-block').find('#select2-location-widget__input-in-to-container').text();
				localStorage.setItem('cityTo', city1 + ` (${codeForm})`);
				if ($('.location-widget__wrap').hasClass('items-swapped')) {
					$('.form-block').find('.location-from input').val(`${city1} (${codeForm})`.toUpperCase());
				} else {
					$('.form-block').find('.location-to input').val(`${city1} (${codeForm})`.toUpperCase());
				}
				/* $('.form-block').find('.location-from input').text(`${city1} (${codeForm})`); */
			});

			$('.form-block').find('.js-location-select-second').on('select2:select', function() {
				$('.form-block').find('.js-location-select-second').addClass('select-changed');
				const codeTo = $(this).val().toString();
				console.log(codeTo);
				const city2 = $('.form-block').find('#select2-location-widget__input-in-from-container').text();
				localStorage.setItem('cityFrom', city2 + ` (${codeTo})`);
				if ($('.location-widget__wrap').hasClass('items-swapped')) {
					$('.form-block').find('.location-to input').val(`${city2} (${codeTo})`.toUpperCase());
				} else {
					$('.form-block').find('.location-from input').val(`${city2} (${codeTo})`.toUpperCase());
				}
				/* $('.form-block').find('.location-to input').text(`${city2} (${codeTo})`); */
			});
		}

	},

	locationSelect2Second: (selector) => {
		/**
		 * @description Select2 global function
		 * @link Documentation https://select2.org/
		 * @type {object}
		 */

		// Gets data from location-widget.php, from acf
		const location = window.locationsSecond;
		const placeholder = window.placeholderText;
		selector.each(function(e, el) {
			$(el).select2({
				minimumResultsForSearch: 1,
				width: 'style',
				dropdownCssClass: 'custom-class',
				placeholder: placeholder,
				data: [
					// Parse location array
					...location.map((item) => {
						return {
							id: item['code'].toLowerCase(),
							text: item['address'].toLowerCase(),
						};
					}),
				],
				matcher: Select2.matchCustom
			});
		});
	},

	matchCustom(params, data) {
		// If there are no search terms, return all of the data
		if ($.trim(params.term) === '') {
			return data;
		}

		// Do not display the item if there is no 'text' property
		if (typeof data.text === 'undefined') {
			return null;
		}

		//Make it not be case sensitive
		const term = params.term.toLowerCase();

		// `params.term` should be the term that is used for searching
		// `data.text` is the text that is displayed for the data object
		if (data.text.indexOf(term) > -1) {
			const modifiedData = $.extend({}, data, true);
			modifiedData.text;

			// You can return modified objects from here
			// This includes matching the `children` how you want in nested data sets
			return modifiedData;
		}

		// Check if data.title exist and return it if it does
		/* if (data.title.indexOf(term) > -1) {
			const modifiedData = $.extend({}, data, true);
			modifiedData.text;
			return modifiedData;
		} */

		if (data.id.indexOf(term) > -1) {
			const modifiedData = $.extend({}, data, true);
			modifiedData.text;
			return modifiedData;
		}

		// Return `null` if the term should not be displayed
		return null;
	}
};

export default Select2;
